import React from 'react';
import { Link, graphql, useStaticQuery } from 'gatsby';
import kebabCase from 'lodash/kebabCase';

import LinkBox from './link-box';

const TopCategories = () => {
  const data = useStaticQuery(graphql`
    query {
      commoncategoriesQuery: allEpisodesJson {
        group(field: categories) {
          fieldValue
          totalCount
        }
      }
    }
  `);

  data.commoncategoriesQuery.group.sort((a, b) => b.totalCount - a.totalCount);

  return (
    <>
      <div className="mb-5 flex flex-wrap justify-between items-center">
        <h3 className="whitespace-nowrap">Top categories</h3>{' '}
        <span className="text-lg border-b border-gray-600 whitespace-nowrap mt-3">
          <Link to="/categories">Browse all →</Link>
        </span>
      </div>
      <ul className="flex flex-wrap gap-3 list-none">
        {data.commoncategoriesQuery.group.slice(0, 15).map((category) => (
          <li key={category.fieldValue} className="text-sm md:text-lg">
            <LinkBox
              href={`/categories/${kebabCase(
                category.fieldValue.replace(/^\w+_/, '')
              )}/`}
            >
              {category.fieldValue.replace(/^\w+_/, '')} ({category.totalCount})
            </LinkBox>
          </li>
        ))}
      </ul>
    </>
  );
};

export default TopCategories;
